import { RouteConfig } from 'vue-router';

const securityRoute = [
	{
		path: '/reset',
		name: 'createpassword',
		component: () => import(
			/* webpackChunkName: "create-password" */
			'../../views/login/CreatePassword.vue'
		)
	},
	{
		path: '/mot-de-passe-oublie',
		name: 'resetpassword',
		component: () => import(
			/* webpackChunkName: "reset-password" */
			'../../views/login/ResetPassword.vue'
		)
	},
	{
		path: '/accessmaster',
		name: 'accessmaster',
		component: () => import(
			/* webpackChunkName: "accessmaster" */
			'../../accessMaster/AccessMasterMockForm.vue'
		)
	},
	{
		path: '/connexion',
		name: 'login',
		component: () => import(
			/* webpackChunkName: "login" */
			'../../views/login/Login.vue'
		)
	},
	{
		path: '/sms-validation',
		name: 'smsValidation',
		component: () => import(
			/* webpackChunkName: "smsvalidation" */
			'../../views/login/SmsValidation.vue'
		),
		meta: {
			disableNavigation: true
		}
	},
	{
		path: '/terms-conditions/validation',
		name: 'termConditionValidation',
		component: () => import(
			/* webpackChunkName: "termConditionValidation" */
			'../../views/login/TermConditionValidation.vue'
		),
		meta: {
			disableNavigation: true
		}
	},
	{
		path: '/acces-refuse',
		name: 'unauthorized',
		component: () => import(
			/* webpackChunkName: "unauthorized" */
			'../../views/exception/Unauthorized.vue'
		)
	}
] as RouteConfig[];

export default securityRoute;
